/* eslint-disable no-unused-vars */
import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid2,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

export default function DeleteScheduleModal({
  open,
  onClose,
  onConfirm,
  scheduleDate,
}) {
  const theme = useTheme();

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "500px",
          bgcolor: "background.paper",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
          //   textAlign: "center",
          direction: "rtl",
        }}
      >
        {/* Modal Header */}
        <Grid2
          container
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography id="add-schedule-modal" variant="h6">
            حذف روز تمرین {scheduleDate}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid2>
        <Typography variant="body1" sx={{ mb: 3 }}>
          آیا از حذف این روز تمرین مطمئن هستید؟
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 3,
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            انصراف
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            حذف
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
